import { DeepEqual } from "@Utils/Object/DeepEqual";

type PrimaryKey = string | number;

interface ICacheService {

    has(primaryKey: PrimaryKey, extraKeys: any): boolean;
    get<T = any>(primaryKey: PrimaryKey, extraKeys: any): T;
    set(primaryKey: PrimaryKey, extraKeys: any, value: any): void;
    remove(primaryKey: PrimaryKey, extraKeys: any): void;
    clean(): void;
}

interface CacheItem {
    extraKeys: any;
    response: any;
}

class CacheService implements ICacheService {

    private cache: { [primaryKey: string]: CacheItem[] } = {};

    has(primaryKey: PrimaryKey, extraKeys: any) {

        return Object.hasOwnProperty.call(this.cache, primaryKey)
            && this.cache[primaryKey].findIndex(i => DeepEqual(i.extraKeys, extraKeys)) > -1;
    }

    get<T = any>(primaryKey: PrimaryKey, extraKeys: any): T {

        return this.cache[primaryKey]?.find(i => DeepEqual(i.extraKeys, extraKeys)).response;
    }

    set(primaryKey: PrimaryKey, extraKeys: any, value: any) {

        this.remove(primaryKey, extraKeys);
        if (!this.cache[primaryKey]) { this.cache[primaryKey] = []; }
        this.cache[primaryKey].unshift({ response: value, extraKeys });
    }

    remove(primaryKey: PrimaryKey, extraKeys: any) {

        if (this.cache[primaryKey] && extraKeys !== undefined) {

            this.cache[primaryKey] = this.cache[primaryKey].filter(i => !DeepEqual(i.extraKeys, extraKeys));
        }
        else if (this.cache[primaryKey] && extraKeys === undefined) {

            delete this.cache[primaryKey];
        }
    }

    clean() {

        this.cache = {};
    }
}

class MockCacheService implements ICacheService {
    has() { return false; }
    get<T = any>(): T { return undefined; }
    set() {}
    remove() {}
    clean() {}
}

export function CreateCache() {

    return window["$$angularUnitTestsMode"]
        ? new MockCacheService()
        : new CacheService();
}
